import { style } from '@vanilla-extract/css';

const root = {
  height: '100vh',
};

const header = {
  padding: '2.1rem 5.1rem',
};

const content = {
  padding: '18.8rem 27.9rem',
};

const errorCode = {
  color: 'rgba(var(--grey-color-4-rgb), 0.6)',
  fontWeight: 'bold',
  fontSize: '1.6rem',
  lineHeight: '2.6rem',
};

const title = {
  marginTop: '2.2rem',
  color: 'var(--grey-color-4)',
  fontWeight: 'bold',
  fontSize: '3.2rem',
  lineHeight: '4rem',
};

const description = {
  maxWidth: '49.8rem',
  marginTop: '1.3rem',
  marginBottom: '6rem',
  color: 'rgba(var(--grey-color-4-rgb), 0.6)',
  fontSize: '1.6rem',
  lineHeight: '2.6rem',
};

export const css = {
  root: style(root),
  header: style(header),
  content: style(content),
  errorCode: style(errorCode),
  title: style(title),
  description: style(description),
};
